import React from "react";
import {AppendRowsConfiguration} from "./configuration/append-rows-configuration";
import {PreviewTab} from "../preview-tab/preview-tab";

export const AppendRowsStepPanelTabs = {
    configuration: AppendRowsConfiguration,
    preview: PreviewTab,
};
